// The SPA's page title.
//
// Rails server-renders a correct, page-specific <title> into the shell for
// every public SEO surface (/quest/:slug, /meme/:text, /stream/:uuid, /memes,
// /streams). Googlebot indexes the RENDERED title, so if the app overwrites it
// with a constant the whole corpus lands in the index titled "Treechat".
//
// The SSR title is therefore captured once at boot and treated as the base;
// the notification counter only ever decorates it, and client-side navigation
// updates it via setDocumentBaseTitle.
const FALLBACK_TITLE = 'Treechat'

let baseTitle = typeof document !== 'undefined' ? document.title || FALLBACK_TITLE : FALLBACK_TITLE
let notificationCount = 0

// Titles derivable from the URL alone. Routes whose title depends on loaded
// data fall back to the brand title rather than retaining the previous page's
// title after client-side navigation.
export function documentTitleForPath(pathname?: string | null): string {
    const path = (pathname || '').split(/[?#]/, 1)[0].replace(/\/+$/, '')
    if (path === '/memes') return 'Memes — Treechat'
    if (path === '/streams') return 'Channels — Treechat'

    const memeMatch = path.match(/^\/meme\/([^/]+)$/)
    if (memeMatch) {
        try {
            return `${decodeURIComponent(memeMatch[1]).split('-').join(' ')} — Treechat`
        } catch {
            return FALLBACK_TITLE
        }
    }

    return FALLBACK_TITLE
}

function render() {
    if (typeof document === 'undefined') return
    const title = baseTitle || FALLBACK_TITLE
    document.title = notificationCount ? `(${notificationCount}) ${title}` : title
}

// Page-level title (no notification count). Pass a blank value to fall back to
// the generic brand title.
export function setDocumentBaseTitle(title?: string | null) {
    baseTitle = (title || '').trim() || FALLBACK_TITLE
    render()
}

export function setDocumentTitleForPath(pathname?: string | null) {
    setDocumentBaseTitle(documentTitleForPath(pathname))
}

export function getDocumentBaseTitle() {
    return baseTitle
}

export function setTitleNotificationCount(count: number) {
    notificationCount = Number(count) || 0
    render()
}
